module.exports = __webpack_public_path__ + "img/1762141139961-OVWVX9Na.f9c50766.png";